import DrugStandardLabel from './DrugStandardLabel';

export default DrugStandardLabel;
